import React, { useContext } from 'react'
import { Button, LinkButton } from '~/lib/ui/button'
import useTranslation, {
  TranslationContext,
  TranslationProvider,
} from '../TranslationProvider'
import translations from '../locales.json'

const metaContent = (name) =>
  document.querySelector(`meta[name="${name}"]`)?.content

const helpdeskHref = () => {
  const email = metaContent('helpdesk-email')
  if (!email) return null

  const subject = metaContent('helpdesk-subject')
  return subject
    ? `mailto:${email}?Subject=${encodeURIComponent(subject)}`
    : `mailto:${email}`
}

const AylaTimeoutErrorContent = ({ onRetry, className = '' }) => {
  const { t } = useTranslation()
  const supportHref = helpdeskHref()

  return (
    <div
      role="alert"
      className={`flex flex-col items-center gap-4 p-4 text-center ${className}`}
    >
      <p className="text-base">
        {t('message')} {t('contact_support_message')}
      </p>
      <div className="flex flex-wrap items-center justify-center gap-4">
        {onRetry && (
          <Button type="button" onClick={onRetry}>
            {t('try_again')}
          </Button>
        )}
        {supportHref && (
          <LinkButton
            href={supportHref}
            variant="outline"
            target="_blank"
            rel="noopener noreferrer"
          >
            {t('contact_support')}
          </LinkButton>
        )}
      </div>
    </div>
  )
}

const AylaTimeoutError = ({ locale, ...props }) => {
  const context = useContext(TranslationContext)

  return (
    <TranslationProvider
      locale={locale || context?.providerLocale || 'en'}
      translations={translations}
      scope="javascript.components.shared.ayla_timeout"
    >
      <AylaTimeoutErrorContent {...props} />
    </TranslationProvider>
  )
}

export {
  default as useAylaTimeout,
  aylaPost,
  AYLA_TIMEOUT_MS,
} from './useAylaTimeout'
export default AylaTimeoutError
